import React, { useState } from 'react';
import { X } from 'lucide-react';
export function AnnouncementBar() {
  const [isVisible, setIsVisible] = useState(true);
  if (!isVisible) return null;
  return <div className="bg-sand text-espresso py-3 px-4 text-center relative" data-id="element-14">
      <div className="flex items-center justify-center gap-4 text-xs uppercase tracking-widest" data-id="element-15">
        <span data-id="element-16">FREE SHIPPING ON ORDERS OVER $75</span>
        <a href="#" className="underline hover:text-rust transition-colors" data-id="element-17">
          Shop New Arrivals
        </a>
      </div>
      <button onClick={() => setIsVisible(false)} className="absolute right-4 top-1/2 -translate-y-1/2 hover:text-rust transition-colors" aria-label="Dismiss announcement" data-id="element-18">
        <X size={16} data-id="element-19" />
      </button>
    </div>;
}